import { render } from "./fullScreenCallDisplaySize.vue?vue&type=template&id=d333650e&scoped=true"
import script from "./fullScreenCallDisplaySize.vue?vue&type=script&lang=js"
export * from "./fullScreenCallDisplaySize.vue?vue&type=script&lang=js"

import "./fullScreenCallDisplaySize.vue?vue&type=style&index=0&id=d333650e&scoped=true&lang=css"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d333650e"]])

export default __exports__